import { render, staticRenderFns } from "./node.vue?vue&type=template&id=1945ac76"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"
import style0 from "./node.vue?vue&type=style&index=0&id=1945ac76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports